import React, { useState } from "react";

const EmailVerificationModal = props => {
  const { office, closeModal } = props;
  const [errorMsg, setErrorMsg] = useState(null);
  const [formIsSubmitting, setFormIsSubmitting] = useState(false);
  const submitForm = async e => {
    e.preventDefault();
    setErrorMsg(null);
    setFormIsSubmitting(true);
    const formData = new FormData(e.target);
    const email = formData.get("email");

    const emailRegex = /\S+@\S+\.\S+/;
    if (!emailRegex.test(email) || !email) {
      setErrorMsg("Please enter a valid email address.");
      setFormIsSubmitting(false);
      return;
    }

    const { grecaptcha } = window;

    // Site Key owned by Stewart Title
    // As of August 2025, was not configured to work with localhost requests
    // so this will never submit successfully in Storybook.
    const SITE_KEY = `6Lc8rwYaAAAAAGsJKqZhD-FjPHtuq1D56kx47AnM`;

    const grecaptchaToken = await grecaptcha.execute(SITE_KEY, {
      action: "submit",
    });

    if (grecaptchaToken) {
      try {
        const response = await fetch(
          "https://iwrsaiki86.execute-api.us-east-1.amazonaws.com/api/forms/agency-verification",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              officeInfo: "",
              blockName: "office-listing-card",
              blockStatus: "loaded",
              officeAddress1: office.details.mailingAddress.street,
              officeAddress2: office.details.mailingAddress.street2,
              city: office.details.mailingAddress.city,
              state: office.details.mailingAddress.state,
              zip: office.details.mailingAddress.zip,
              srvsState: office.serviceState,
              officeDisplayName: office.details.title,
              grecaptchaToken: grecaptchaToken,
              email: email,
            }),
          },
        );

        if (response.ok || response.status === 204) {
          setFormIsSubmitting(false);
          closeModal();
        } else {
          setFormIsSubmitting(false);
          console.error(
            "Failed to send email",
            response.status,
            response.statusText,
          );
        }
      } catch (error) {
        setFormIsSubmitting(false);
        console.error("Error:", error);
      }
    }
  };
  return (
    <div className="email-verification-modal">
      <div className="email-verification-modal__inner">
        <div className="email-verification-modal__close" onClick={closeModal}>
          <i className="fal fa-times" aria-hidden="true" />
        </div>
        <div className="email-verification-modal__title">
          Email Verification Letter
        </div>
        <form
          onSubmit={e => {
            submitForm(e);
          }}
        >
          <input type="email" name="email" placeholder="Email" />
          {errorMsg && (
            <div className="email-verification-modal__error">{errorMsg}</div>
          )}
          <div className="email-verification-modal__attachment">
            <i className="fal fa-paperclip" aria-hidden="true" />
            {office.details.title} Verification Letter
          </div>
          <button
            disabled={formIsSubmitting}
            className="btn btn--primary"
            type="submit"
          >
            Send Email{" "}
            {formIsSubmitting && (
              <i className="fal fa-spinner" aria-hidden="true" />
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmailVerificationModal;
